import { Pipe, PipeTransform } from '@angular/core';
import { AppDate } from '@macs-frontend/core/utils/date';
import { FormControlState } from 'ngrx-forms';

@Pipe({ name: 'asDateControl', pure: true })
export class AsDateControlPipe implements PipeTransform {
  public transform<T extends null | string>(
    value: FormControlState<T>,
  ): FormControlState<T extends null ? null : AppDate> {
    return value as unknown as FormControlState<T extends null ? null : AppDate>;
  }
}
